import InspirationTranslationResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/InspirationSerivce/InspirationTranslationResponse";

export default class InspirationTranslateModel {
    langCode: string = '';
    text: string = '';
    constructor(obj?: Partial<InspirationTranslateModel>) {
        if (obj) {
            this.langCode = obj.langCode;
            this.text = obj.text;
        }
    }
    toServerModel(): InspirationTranslationResponse {
        return new InspirationTranslationResponse({
            LangCode: this.langCode,
            Text: this.text
        });
    }
    fromServerModel(res: InspirationTranslationResponse) {
        this.langCode = res.LangCode;
        this.text = res.Text;
    }
}